import React from "react";
import Vars from "Consts/vars";
import NextImage from "Components/fallback_image/next_image";

const CardArticle = (props) => {

	const prop = props;

	return (
		<div className="container-search-article">
			<a href={prop.url}>
				<div className="card-article">
					<div className="card-article__section-image-article">
						<NextImage
							width={312}
							height={208}
							placeholder="article"
							layout="responsive"
							objectFit="cover"
							style={{ borderRadius: 4 }}
							src={prop.image}
							alt={prop.label}
							fallbackSrc={Vars.BROKEN_IMAGE.rectangle}
						/>
					</div>

					<div className="card-article__section-text">
						<p className="card-article__category">{prop.category}</p>
						<p className="card-article__article-title">{prop.title}</p>
						<p className="card-article__author">
							by
							{" "}
							{prop.author}
						</p>
					</div>

				</div>
			</a>

			<style jsx>
				{`
				.container-search-article {
					word-wrap: break-word;
				}
					.card-article {
						gap: 8px;
						align-items: center;
						margin-bottom: 12px;
					}
					.card-article__section-image-article{
						position: relative;
						width: 100%; /* Lebar penuh untuk mengisi kolom grid */
						overflow: hidden;
					}

					.card-article__section-image-article img {
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
						height: 100%;
						object-fit: cover; /* Memastikan gambar terisi penuh di dalam kotak */
					}
					.card-article__image-article{
						width: 100%;
						height: 100%;
						border-radius: 4px;
						object-fit: cover;
					}
					.card-article__section-text{
						//max-width: 318px;
					}
					.card-article__category{
						font-family: 'Creato Display';
						font-style: normal;
						font-weight: 400;
						font-size: 12px;
						line-height: 16px;
						color: #DB284E;
						margin-bottom: 2px;
						margin-top: 12px;

						text-overflow: ellipsis;
						-webkit-line-clamp: 1;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						overflow: hidden;
					}
					.card-article__article-title{
						font-family: 'Butler';
						font-style: normal;
						font-weight: 700;
						font-size: 16px;
						line-height: 24px;
						text-transform: capitalize;
						color: #13161A;
						text-overflow: ellipsis;
						-webkit-line-clamp: 3;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						overflow: hidden; 
  
					}
					.card-article__author{
						font-family: 'Creato Display';
						font-style: normal;
						font-weight: 400;
						font-size: 12px;
						line-height: 16px;
						color: #919EAB;
					}
				`}
			</style>

		</div>
	);

};

export default CardArticle;
